// WhatsApp helper: build context-aware prefilled messages from current page
import { useEffect, useState } from "react";

const NUMBER = "491758802646";

const TEMPLATES = {
  de: {
    default: "Hallo Talkani, ich interessiere mich für Ihre Dienstleistungen. Können Sie mir bitte mehr Informationen geben?",
    landing: "Hallo Talkani, ich habe Ihre Website besucht und interessiere mich für eine Buchung. Können Sie mir helfen?",
    booking: "Hallo Talkani, ich möchte ein Angebot für {service}. Können wir die Details besprechen?",
    service: "Hallo Talkani, ich interessiere mich für „{service}\". Was kostet das und wann können Sie kommen?",
    blog: "Hallo Talkani, ich habe Ihren Artikel gelesen und hätte eine Frage dazu.",
    plz: "Hallo Talkani, beliefern Sie die PLZ {plz}? Ich bräuchte {service}.",
  },
  en: {
    default: "Hello Talkani, I'm interested in your services. Could you give me more information?",
    landing: "Hello Talkani, I visited your website and I'd like to make a booking. Can you help me?",
    booking: "Hello Talkani, I'd like a quote for {service}. Can we discuss the details?",
    service: "Hello Talkani, I'm interested in \"{service}\". What's the cost and when can you come?",
    blog: "Hello Talkani, I read your article and have a question about it.",
    plz: "Hello Talkani, do you serve the postal code {plz}? I'd need {service}.",
  },
  ar: {
    default: "مرحباً تالكاني، أنا مهتم بخدماتكم. هل يمكنكم إعطائي مزيداً من المعلومات؟",
    landing: "مرحباً تالكاني، زرتُ موقعكم وأودّ إجراء حجز. هل يمكنكم مساعدتي؟",
    booking: "مرحباً تالكاني، أريد عرض سعر لخدمة {service}. هل يمكننا مناقشة التفاصيل؟",
    service: "مرحباً تالكاني، أنا مهتم بخدمة «{service}». ما التكلفة ومتى يمكنكم الحضور؟",
    blog: "مرحباً تالكاني، قرأتُ مقالكم ولديّ سؤال بشأنه.",
    plz: "مرحباً تالكاني، هل تخدمون الرمز البريدي {plz}؟ أحتاج إلى خدمة {service}.",
  },
};

export function getContextualMessage(lang, ctx = {}) {
  const pool = TEMPLATES[lang] || TEMPLATES.de;
  const path = typeof window !== "undefined" ? window.location.pathname : "/";

  let key = "landing";
  if (path.startsWith("/book")) key = "booking";
  else if (path.startsWith("/blog")) key = "blog";
  else if (ctx.service) key = "service";
  else if (ctx.plz) key = "plz";
  else if (path === "/") key = "landing";

  const template = pool[key] || pool.default;
  return template
    .replace("{service}", ctx.service || (lang === "ar" ? "خدمة عامة" : lang === "en" ? "a service" : "eine Dienstleistung"))
    .replace("{plz}", ctx.plz || "");
}

export function buildWhatsAppUrl(message) {
  return `https://wa.me/${NUMBER}?text=${encodeURIComponent(message)}`;
}

/**
 * React hook that returns a WhatsApp URL that re-computes when the route changes.
 */
export function useWhatsAppUrl(lang, ctx) {
  const [url, setUrl] = useState(() => buildWhatsAppUrl(getContextualMessage(lang, ctx)));
  useEffect(() => {
    setUrl(buildWhatsAppUrl(getContextualMessage(lang, ctx)));
    // Update on route change (SPA pushState)
    const handler = () => setUrl(buildWhatsAppUrl(getContextualMessage(lang, ctx)));
    window.addEventListener("popstate", handler);
    return () => window.removeEventListener("popstate", handler);
  }, [lang, ctx?.service, ctx?.plz]);
  return url;
}
